export default [
  {
    path: 'cotacao-conjunta/:id',
    name: 'main.compra-conjunta.cotacao',
    components: {
      default: () => import(/* webpackChunkName: "cotacao-conjunta" */ '@/modules/compra-conjunta/CotacaoConjuntaDetalhes.vue'),
    },
  },
  {
    path: 'cotacao-conjunta/:id/resposta',
    name: 'main.compra-conjunta.cotacao.resposta',
    components: {
      default: () => import(/* webpackChunkName: "cotacao-conjunta-resposta" */ '@/modules/compra-conjunta/responder/CotacaoConjuntaResposta.vue'),
    },
  },
  {
    path: 'cotacao-conjunta/:id/resposta/:idResposta',
    name: 'main.compra-conjunta.cotacao.resposta.edicao',
    components: {
      default: () => import(/* webpackChunkName: "cotacao-conjunta-resposta-id" */ '@/modules/compra-conjunta/responder/CotacaoConjuntaResposta.vue'),
    },
  },
  {
    path: 'cotacao-conjunta/:id/minha-resposta',
    name: 'main.compra-conjunta.cotacao.minha-resposta',
    components: {
      default: () => import(/* webpackChunkName: "cotacao-conjunta-minha-resposta" */ '@/modules/compra-conjunta/minha-resposta/CotacaoConjuntaMinhaResposta.vue'),
    },
  },
  {
    path: 'venda-conjunta/:id',
    name: 'main.venda-conjunta.venda',
    components: {
      default: () => import(/* webpackChunkName: "cotacao-conjunta-vendas" */ '@/modules/venda-conjunta/VendaConjunta.vue'),
    },
  },
];
